import { TournamentState } from '@ps/poker-games-tile-mappers';

export const unorderedTournaments = [
  {
    __typename: 'Tournament',
    id: 8,
    whenStartInt: 1707047100,
    regEndInt: 1706793420,
    formattedState: TournamentState.LATE_REGISTRATION
  },
  {
    __typename: 'Tournament',
    id: 6,
    whenStartInt: 1707038100,
    regEndInt: 1706793000,
    formattedState: TournamentState.LATE_REGISTRATION
  },
  {
    __typename: 'Tournament',
    id: 7,
    whenStartInt: 1707039900,
    regEndInt: 1706793300,
    formattedState: TournamentState.LATE_REGISTRATION
  },
  {
    __typename: 'Tournament',
    id: 1,
    whenStartInt: 1698345000,
    regEndInt: 1698351300,
    formattedState: TournamentState.REGISTERING
  },
  {
    __typename: 'Tournament',
    id: 2,
    whenStartInt: 1698345000,
    regEndInt: 1698351300,
    formattedState: TournamentState.REGISTERING
  },
  {
    __typename: 'Tournament',
    id: 3,
    whenStartInt: 1698345000,
    regEndInt: 1698351300,
    formattedState: TournamentState.RUNNING
  },
  {
    __typename: 'Tournament',
    id: 4,
    whenStartInt: 1698345000,
    regEndInt: 1698351300,
    formattedState: TournamentState.COMPLETED
  },
  {
    __typename: 'Tournament',
    id: 5,
    whenStartInt: 1698345000,
    regEndInt: 1698351300,
    formattedState: TournamentState.REGISTERING
  }
];

export const orderedTournaments = [
  {
    __typename: 'Tournament',
    id: 4,
    whenStartInt: 1698345000,
    regEndInt: 1698351300,
    formattedState: TournamentState.COMPLETED
  },
  {
    __typename: 'Tournament',
    id: 3,
    whenStartInt: 1698345000,
    regEndInt: 1698351300,
    formattedState: TournamentState.RUNNING
  },
  {
    __typename: 'Tournament',
    id: 6,
    whenStartInt: 1707038100,
    regEndInt: 1706793000,
    formattedState: TournamentState.LATE_REGISTRATION
  },
  {
    __typename: 'Tournament',
    id: 7,
    whenStartInt: 1707039900,
    regEndInt: 1706793300,
    formattedState: TournamentState.LATE_REGISTRATION
  },
  {
    __typename: 'Tournament',
    id: 8,
    whenStartInt: 1707047100,
    regEndInt: 1706793420,
    formattedState: TournamentState.LATE_REGISTRATION
  },
  {
    __typename: 'Tournament',
    id: 1,
    whenStartInt: 1698345000,
    regEndInt: 1698351300,
    formattedState: TournamentState.REGISTERING
  },
  {
    __typename: 'Tournament',
    id: 2,
    whenStartInt: 1698345000,
    regEndInt: 1698351300,
    formattedState: TournamentState.REGISTERING
  },
  {
    __typename: 'Tournament',
    id: 5,
    whenStartInt: 1698345000,
    regEndInt: 1698351300,
    formattedState: TournamentState.REGISTERING
  }
];
